<template>
  <el-container id="loginPage">
    <div class="contentBox">
      <el-image class="leftImg" :src="leftImgUrl" fit="fill"></el-image>
      <div class="loginBox">
        <div class="titleCls">上品尚生</div>
        <div class="inputBox">
          <i class="iconfont icon-yonghuming iconCls"></i>
          <el-input placeholder="请输入用户名" v-model="userName"></el-input>
        </div>
        <div class="inputBox">
          <i class="iconfont icon-mima iconCls"></i>
          <el-input type="password" placeholder="请输入密码" v-model="password"></el-input>
        </div>
        <el-button class="loginBtn" type="primary" round @click="loginAction">登录</el-button>
      </div>
    </div>
  </el-container>
</template>

<script>
import '@/assets/fonts/iconfont.css';
import pathKey from '@/router/routerKey';
import { setStore, userInfo_key} from '@/utils/localCache';

export default {
  name: 'loginPage',
  data() {
    return {
      leftImgUrl: require('@/assets/loginLeftImg.png'),
      userName: '',
      password: ''
    };
  },
  methods: {
    loginAction() {
      if (this.userName != 'spss' || this.password != '123') {
        this.$message({
          message: '用户名和密码不匹配!',
          type: 'error',
          center: true,
          offset: 300
        });
        return;
      }
      //------------------暂时这样处理
      var userInfo = {
        userName: this.userName,
        password: this.password
      }
      setStore(userInfo_key, userInfo);
      this.$router.push(pathKey.homePath);
    }
  }
}
</script>

<style scoped>
#loginPage {
  width: 100vw;
  height: 100vh;
  background-image: url('../../assets/loginBackImg.png');
}
.contentBox {
  margin: auto;
  width: 80%;
  height: 80%;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 0px 2px #FFF; 
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.leftImg {
  display: inline-block;
  width: 45%;
  height: 65%;
  margin-left: 33px;
}
.loginBox {
  width: 30%;
  align-items: center;
}
.titleCls {
  font-size: 40px;
  color: #333;
  padding-bottom: 40px;
}
.inputBox {
  width: 100%;
  margin-top: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.el-input {
  width: 80%;
}
.iconCls {
  display: inline-block;
  color: #2592FA;
  font-size: 26px;
}
.loginBtn {
  width: 100%;
  margin-top: 60px;
}

</style>



// WEBPACK FOOTER //
// src/components/login/loginPage.vue